"use client";

import { useAuth } from '@/auth/hooks/clerk-hooks';
import { rpcTanstackClient } from '@/features/api/internal/client';
import { useQuery } from '@tanstack/react-query';

import {
  createContext,
  useContext
} from 'react';

type UserContextType = {
  isLoading: boolean;
  files: Array<any> | [];
};

export const UserContext = createContext<UserContextType | undefined>(
  undefined
);

export interface Props {
  [propName: string]: any;
}

const EMPTY_FOLDERS: Array<any> = [];

export const MyUserContextProvider = (props: Props) => {
  const { isLoaded, isSignedIn } = useAuth();

  const { data: folders = EMPTY_FOLDERS, isLoading } = useQuery(
    rpcTanstackClient.folder.list.queryOptions({
      queryKey: ["folders", "all"],
      enabled: isLoaded && Boolean(isSignedIn),
      select: (payload) =>
        payload.map((folder) => ({
          ...folder,
          name: /^\d+_example$/.test(folder.name) ? 'Example Materials' : folder.name,
        })),
    })
  );

  const value = {
    isLoading: !isLoaded || (Boolean(isSignedIn) && isLoading),
    files: folders,
  };

  return <UserContext.Provider value={value} {...props} />;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error(`useUser must be used within a MyUserContextProvider.`);
  }
  return context;
};
